/**
 * Normalize playerClass to abbreviated display format.
 * e.g., "Freshman" -> "FR", "Sophomore" -> "SO", "R-Freshman" -> "R-FR", "R-Sophomore" -> "R-SO"
 */
export const normalizePlayerClass = (playerClass) => {
  if (!playerClass) return '-';
  const classMap = {
    'freshman': 'FR',
    'fr': 'FR',
    'fr.': 'FR',
    'sophomore': 'SO',
    'so': 'SO',
    'so.': 'SO',
    'junior': 'JR',
    'jr': 'JR',
    'jr.': 'JR',
    'senior': 'SR',
    'sr': 'SR',
    'sr.': 'SR',
    'r-freshman': 'RS-FR',
    'r-fr': 'RS-FR',
    'r-fr.': 'RS-FR',
    'rs-freshman': 'RS-FR',
    'rs-fr': 'RS-FR',
    'rs-fr.': 'RS-FR',
    'r-sophomore': 'RS-SO',
    'r-so': 'RS-SO',
    'r-so.': 'RS-SO',
    'rs-sophomore': 'RS-SO',
    'rs-so': 'RS-SO',
    'rs-so.': 'RS-SO',
    'r-junior': 'RS-JR',
    'r-jr': 'RS-JR',
    'r-jr.': 'RS-JR',
    'rs-junior': 'RS-JR',
    'rs-jr': 'RS-JR',
    'rs-jr.': 'RS-JR',
    'r-senior': 'RS-SR',
    'r-sr': 'RS-SR',
    'r-sr.': 'RS-SR',
    'rs-senior': 'RS-SR',
    'rs-sr': 'RS-SR',
    'rs-sr.': 'RS-SR',
    'red shirt': 'RS',
    'redshirt': 'RS',
    'redshirt freshman': 'RS-FR',
    'redshirt sophomore': 'RS-SO',
    'redshirt junior': 'RS-JR',
    'redshirt senior': 'RS-SR',
    'redshirt-freshman': 'RS-FR',
'redshirt-sophomore': 'RS-SO',
'redshirt-junior': 'RS-JR',
'redshirt-senior': 'RS-SR',
  };
  return classMap[String(playerClass).toLowerCase().trim()] || playerClass;
};
